import { ITableState } from '../store/slices/tableSlice';

export const setTableUrlParams = (): Partial<ITableState> => {
    const url = new URL(window.location.href);

    const page = url.searchParams.get('page');
    const pageSize = url.searchParams.get('pageSize');

    return Object.fromEntries(
        Object.entries({ page, pageSize })
            .filter(([_, value]) => value)
            .map(([key, value]) => {
                try {
                    return [key, JSON.parse(value!)];
                } catch {
                    return [key, value];
                }
            }),
    );
};
